<template>
    <div class="weeks">
      <!-- 标题 -->
      <div class="subtype">
        <div class="where">用餐类型</div>
        <div class="newfood">菜品/食物</div>
        <div class="picture">图片</div>
      </div>
      <!-- 内容 -->
      <div v-if="weekFoodList.length !==0">
        <div class="content" v-for="(item,index) in weekFoodList" :key="index">
          <div class="breakfast">{{item.mealsType}}</div>
          <div class="breakfast1">
            <ul v-for="(foods,i) in item.foodsList" :key ="'1'+i" >
              <li>{{foods.recipeConncts[0].dishName}}</li>
            </ul>
          </div>
          <div class="columnimg">
            <img :src="item.foodsList[0].pic" alt="" />
          </div>
        </div>
      </div>
      <div v-else>
        <van-row type="flex" justify="center" style="margin-top:20px">
          <van-col span="6" style="color: #b4babf;">暂无食谱</van-col>
        </van-row>
        
      </div>
    </div>
</template>

<script>
// import "@/styles/movie.css";


export default {
  props:['weekFoodList'],
  mounted(){

  },
  data() {
    return {
      value: "",
      active: 0,
    };
  },
  methods: {

  },
};
</script>

<style scoped>

</style>
